import React, { useMemo } from "react";
import "./CoralRecChart.scss";
import { Bar } from "react-chartjs-2";
import utils from "../../../../helpers/utils";

function CoralRecChart(props) {
  const {
    stats,
    selectedStat,
    handleChartClick,
    selectedChart,
    selectedGeometry,
  } = props;

  const country = utils.getCountryAttrForSelectedGeometry(selectedGeometry);

  /**
   * Build data in format expected by chart.js. Updates based on use selections for geo, stat, chart bar, and beach (eg. stats are updated)
   */
  const data = useMemo(() => {
    const bars = {
      datasets: [
        {
          data: [],
          label: "",
          backgroundColor: ["#2FE4C0", "#EF767A"],
        },
      ],
    };
    if (
      selectedStat &&
      (selectedStat === "Expenditures (USD)" ||
        selectedStat === "Total visitation value (# of people)" ||
        selectedStat === "Total visitation value (number of people)" ||
        selectedStat === "Highest value reefs (top 10%) generate (USD)" ||
        Object.keys(data).length === 0)
    ) {
      if (
        bars.datasets &&
        bars.datasets.length &&
        (selectedStat === "Expenditures (USD)" ||
          selectedStat === "Highest value reefs (top 10%) generate (USD)")
      ) {
        bars.labels = ["Overnight visitors", "Cruise ship passengers"];
        bars.datasets[0].label = " USD";
        bars.datasets[0].data = [
          Number(
            stats["Overnight visitor expenditure (USD)"][country]
              ? stats["Overnight visitor expenditure (USD)"][country].replace(
                  /[^0-9.-]+/g,
                  ""
                )
              : 0
          ),
          Number(
            stats["Cruise ship passenger expenditure (USD)"][country]
              ? stats["Cruise ship passenger expenditure (USD)"][
                  country
                ].replace(/[^0-9.-]+/g, "")
              : 0
          ),
        ];
      }
      if (
        bars.datasets &&
        bars.datasets.length &&
        (selectedStat === "Total visitation value (# of people)" ||
          selectedStat === "Total visitation value (number of people)")
      ) {
        bars.labels = ["Overnight visitors", "Cruise ship passengers"];
        bars.datasets[0].label = " people";
        bars.datasets[0].data = [
          Number(
            stats["Overnight visitors (# of people)"][country]
              ? stats["Overnight visitors (# of people)"][country].replace(
                  /[^0-9.-]+/g,
                  ""
                )
              : 0
          ),
          Number(
            stats["Cruise ship passenger visitors (# of people)"][country]
              ? stats["Cruise ship passenger visitors (# of people)"][
                  country
                ].replace(/[^0-9.-]+/g, "")
              : 0
          ),
        ];
      }

      if (selectedChart === "Overnight") {
        bars.datasets[0].backgroundColor = ["#2FE4C0", "#ccc"];
      }
      if (selectedChart === "Cruise") {
        bars.datasets[0].backgroundColor = ["#ccc", "#EF767A"];
      }
      if (selectedChart === null) {
        bars.datasets[0].backgroundColor = ["#2FE4C0", "#EF767A"];
      }
    }
    return bars;
  }, [country, selectedStat, selectedChart, stats]);

  /**
   * Update which bar is clicked based on index
   */
  const elementClicked = (elements) => {
    if (
      selectedStat === "Expenditures (USD)" ||
      selectedStat === "Total visitation value (# of people)" ||
      selectedStat === "Total visitation value (number of people)"
    ) {
      if (elements[0]?._index === 0) {
        handleChartClick("Overnight");
      }
      if (elements[0]?._index === 1) {
        handleChartClick("Cruise");
      }
    }
  };

  /**
   * bar chart options based on selected stat
   */
  const barOptions = useMemo(() => {
    if (
      selectedStat &&
      (selectedStat === "Expenditures (USD)" ||
        selectedStat === "Total visitation value (# of people)" ||
        selectedStat === "Total visitation value (number of people)" ||
        selectedStat === "Highest value reefs (top 10%) generate (USD)" ||
        Object.keys(barOptions).length === 0)
    ) {
      const options = {
        fontColor: "black",
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                fontColor: "black",
              },
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        maintainAspectRatio: true,
        title: {
          display: true,
          text: selectedStat,
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? "pointer" : "default";
        },
      };

      if (
        selectedStat === "Expenditures (USD)" ||
        selectedStat === "Highest value reefs (top 10%) generate (USD)"
      ) {
        options.scales.yAxes[0].scaleLabel.labelString = "USD";
        options.tooltips = {
          callbacks: {
            label: (tooltipItem, data) => {
              // console.log(tooltipItem);
              let label = "$";
              label += Number(tooltipItem.value).toLocaleString();
              label += data.datasets[tooltipItem.datasetIndex].label;
              return label;
            },
          },
        };
        // eslint-disable-next-line no-unused-vars
        options.scales.yAxes[0].ticks.callback = (value, index, values) => {
          return "$" + Number(value).toLocaleString();
        };
      }
      if (
        selectedStat === "Total visitation value (# of people)" ||
        selectedStat === "Total visitation value (number of people)"
      ) {
        options.scales.yAxes[0].scaleLabel.labelString = "# of People";
        options.tooltips = {
          callbacks: {
            label: (tooltipItem, data) => {
              // console.log(tooltipItem);
              let label = Number(tooltipItem.value).toLocaleString();
              label += data.datasets[tooltipItem.datasetIndex].label;
              return label;
            },
          },
        };
        // eslint-disable-next-line no-unused-vars
        options.scales.yAxes[0].ticks.callback = (value, index, values) => {
          return Number(value).toLocaleString();
        };
      }

      return options;
    }
  }, [selectedStat]);

  return (
    <div className="coralRecTourismChart">
      <Bar
        height={300}
        data={data}
        options={barOptions}
        onElementsClick={elementClicked}
      />
    </div>
  );
}

export default CoralRecChart;
